import { API } from "../../api/API";
import VTAPI from "../../api/VTAPI";
import { validateResponseStatus } from "../../utils";

export const postPurchaseCourse = async (
  userInfoQursiva,
  course,
  tokenQursiva
) => {
  const body = {
    purchase: {
      IdRelacionContacto: userInfoQursiva.userRelationId,
      CreadoPor: userInfoQursiva.email,
    },
    purchaseDetail: [
      {
        IdCurso: course.id,
        Valor: course.value ? course.value : 0,
        CreadoPor: userInfoQursiva.email,
      },
    ],
  };
  const resultPurchase = await API()
    .post("academy/purchase/create", body)
    .catch((error) => {
      return error.response ? error.response : { error };
    });

  return resultPurchase;
};

export const purchaseCourseVT = async (token, request) => {
  const result = await VTAPI(token)
    .post(`/Payment/Pay`, request)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  return result;
};

export const payTransfer = async (data, token) => {
  try {
    return await VTAPI(token).post(`Payment/PayTransfer`, data);
  } catch (error) {
    throw new Error(error);
  }
};

export const updatePurchase = async (token, id, payload) => {
  const result = await API()
    .put(`academy/purchase/update/${id}`, payload)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data[0];
  } else {
    return [];
  }
};

export const getPurchaseQuery = async (token, contactRelationId, purchaseId) => {
  const result = await API()
    .post(`academy/purchase/getByQuery`, { contactRelationId, purchaseId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data.filter((item) => item.total > 0);
  } else {
    return [];
  }
};

export const getPurchase = async (token, purchaseId) => {
  const result = await API()
    .post(`academy/purchase/get`, { purchaseId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};

export const getPurchaseVT = async (token, language, purchaseId) => {
  const result = await API()
    .post(`academy/purchase/getFromVT`, { language, purchaseId })
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  validateResponseStatus(result);
  if (result.status === 200) {
    return result.data;
  } else {
    return [];
  }
};
